import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CancellationReasonsDialogsService} from "../../services/cancellation-reasons-dialogs-service.service";
import {CancellationReasonsService} from "../../services/cancellation-reasons-service.service";
import {CancellationReasonType} from "../../types/cancellation-reason.type";

export class cancellationReasonsViewCtrl implements IController {

  cancellationReasons: any[];
  selectedType: CancellationReasonType;
  actions: any;

  public cancellationReasonsByType: any;
  public cancellationReasonType : typeof CancellationReasonType = CancellationReasonType;

  /* @ngInject */
  constructor(private cancellationReasonsDialogsService: CancellationReasonsDialogsService, private cancellationReasonsService: CancellationReasonsService) {}

  $onInit() {
    this._getCancellationReasonsByType(this.selectedType);
  }

  $onChanges(changes) {
    if (changes.cancellationReasons && !changes.cancellationReasons.isFirstChange()) {
      this.$onInit();
    }
    if (changes.selectedType && !changes.selectedType.isFirstChange()) {
      this.$onInit();
    }
  }

  onTabSelect(type) {
    if (this.selectedType !== type) {
      this.selectedType = type;
      this._getCancellationReasonsByType(type);
    }
  }

  onCreateCancellationReason($event) {
    this.cancellationReasonsDialogsService.createCancellationReason(this.actions, this.selectedType, $event)
      .then((cancellationReason) => {
        this._createCancellationReason(cancellationReason)
      })
  }

  onUpdateCancellationReason(cancellationReason, $event) {
    this.cancellationReasonsDialogsService.updateCancellationReason(this.actions, cancellationReason, $event)
      .then((updatedCancellationReason) => {
        this._updateCancellationReason(updatedCancellationReason)
      })
  }

  onDeleteCancellationReason(cancellationReasonId, $event) {
    this.cancellationReasonsService.deleteCancellationReason(cancellationReasonId)
      .then((removedCancellationReason) => {
         _.remove(this.cancellationReasons, (reason: any) => {
            return reason.id == removedCancellationReason.id;
         });
         this.$onInit();
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _createCancellationReason(cancellationReason) {
    this.cancellationReasonsService.createCancellationReason(cancellationReason)
      .then((newCancellationReason) => {
        this.cancellationReasons.push(newCancellationReason);
        this.$onInit();
      })
  }

  private _updateCancellationReason(updatedCancellationReason) {
    this.cancellationReasonsService.updateCancellationReason(updatedCancellationReason)
      .then((cancellationReason: any) => {
        const cancellationReasonIdx = _.findIndex(this.cancellationReasons, (cr) => {
          return cr.id == cancellationReason.id;
        })
        this.cancellationReasons.splice(cancellationReasonIdx, 1, cancellationReason);
        this._getCancellationReasonsByType(this.selectedType);
      })
  }

  _getCancellationReasonsByType(type: CancellationReasonType) {
    this.cancellationReasonsByType = _.filter(this.cancellationReasons, (cr) => {
      return cr.typeToCancel === type;
    })
  }

}

angular
  .module('bringoz.admin.cancellation-reasons')
  .component('cancellationReasonsView', {
    bindings: {
      cancellationReasons: '<',
      selectedType: '<',
      actions: '<'
    },
    template: require('./cancellation-reasons-view.html').default,
    controller: cancellationReasonsViewCtrl
  });
